import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Apply from '../views/Apply.vue'
import Close from '../views/Close.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Apply/:EditToken?',
    name: 'Apply',
    component: Apply
  },
  {
    path: '/',
    name: 'Close',
    component: Close
  },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
